import {Component, Input, OnInit} from '@angular/core';
import {ContractObjectBaseComponent} from "../contract-object-base.component";
import {CmContractInlineObjectViewTypeUiEnum} from "./view-type/view-type.enum";
import {ObjectRequestList} from "../../../../../../../../core/shared/dto/object/request/object-request-list";
import {FilterCriteria} from "../../../../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestComplex} from "../../../../../../../../core/shared/dto/object/request/object-request-complex";
import {
    ObjectRequestComplexNode
} from "../../../../../../../../core/shared/dto/object/request/object-request-complex-node";
import {ActivatedRoute} from "@angular/router";
import {MvsObjectNavigationService} from "../../../../../../../../core/shared/navigation/mvs-object-navigation.service";
import {WfProcessService} from "../../../../../../../../feature-core/wf/service/api/wf-process.service";
import {ObserverService} from "../../../../../../../../core/shared/object/service/observer.service";
import {ContractService} from "../../../../../../service/api/contract.service";
import {ContractInsurableObjectService} from "../../../../../../../ci/service/api/contract-insurable-object.service";
import {ContractInsurableObjectDto} from "../../../../../../../ci/model/dto/entity/contract-insurable-object.dto";
import {EntityStatusEnum} from "../../../../../../../../core/shared/entity/enum/entity-status.enum";
import {Sorting} from "../../../../../../../../core/shared/misc/sorting";


@Component({
    selector: 'cm-contract-object-inline-component',
    templateUrl: 'contract-object-inline.component.html',
    standalone: false
})
export class ContractObjectInlineComponent extends ContractObjectBaseComponent implements OnInit {


    @Input() viewType: CmContractInlineObjectViewTypeUiEnum = CmContractInlineObjectViewTypeUiEnum.standard;
    protected readonly CmContractInlineObjectViewTypeUiEnum = CmContractInlineObjectViewTypeUiEnum;

    contractInsurableObjects: ContractInsurableObjectDto[];

    constructor(
        protected route: ActivatedRoute,
        protected navigationService: MvsObjectNavigationService,
        protected processService: WfProcessService,
        protected observerService: ObserverService,
        protected contractService: ContractService,
        protected contractInsurableObjectService: ContractInsurableObjectService
    ) {
        super(route, navigationService, processService, observerService, contractService);
    }

    ngOnInit() {

        if (!this.viewType) {
            this.viewType = CmContractInlineObjectViewTypeUiEnum.standard;
        }

        super.ngOnInit();

    }

    refreshComponent() {

        if (this.viewType === CmContractInlineObjectViewTypeUiEnum.object) {
            this.retrieveContractInsurableObjects();
        } else {
            this.initialized = true;
        }

    }

    retrieveContractInsurableObjects() {

        const now = new Date();
        const isoCurrentDate = now.toISOString()

        const filterCriteria = [
            FilterCriteria.create('contract', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId),
            FilterCriteria.create('entityStatus', FilterCriteria.cOperatorEqual, EntityStatusEnum.active),
            FilterCriteria.create('endDate', FilterCriteria.cOperatorGreaterThan, isoCurrentDate)
        ];

        const objectRequestList = ObjectRequestList.createBasic(false, filterCriteria, [new Sorting('createdDate', false)]);

        objectRequestList.objectRequestComplex = ObjectRequestComplex.build(
            false,
            false,
            ObjectRequestComplexNode.createSimpleAttributeNode("insurableObject").addNodes(
                ObjectRequestComplexNode.createSimpleAttributeNode("type")
            )
        );

        this.contractInsurableObjectService.list(objectRequestList).subscribe(response => {
            this.contractInsurableObjects = response.entries;
            this.initialized = true;
        })
    }

}
